export const PAPER_SIZES = {
  A4: 'A4',
  A6: 'A6',
}

export const PRINT_FORMATS = {
  A4_TOP_LEFT: 'a4-top-left',
  A4_TOP_RIGHT: 'a4-top-right',
  A4_BOTTOM_LEFT: 'a4-bottom-left',
  A4_BOTTOM_RIGHT: 'a4-bottom-right',
  A6_FULL_PAGE: 'a6-full-page',
  A4_FULL_PAGE: 'a4-full-page',
}

export const PRINT_STATUS = {
  PRINTED: 'printed',
  DOWNLOADED: 'downloaded',
  CANCELLED: 'cancelled',
}
